module.exports = __webpack_public_path__ + "media/application/images/svgs/scissors-693028a9fd9f22fca184ae9f3d72addd.svg";